import { render, staticRenderFns } from "./my_inform.vue?vue&type=template&id=283f5d37&scoped=true&"
import script from "./my_inform.vue?vue&type=script&lang=js&"
export * from "./my_inform.vue?vue&type=script&lang=js&"
import style0 from "./my_inform.vue?vue&type=style&index=0&id=283f5d37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5d37",
  null
  
)

export default component.exports